import * as React from 'react';
import { useContext } from 'react';
import { MapUnitDto } from '../../../../../../api/UnitMap';
import { MapContext } from '../../../../../common/UnitMap/UnitMapTypes';
import '../../../../../../styles/UnitMapConfiguration.css';
import Button from '../../../../../common/form/Button';
import { Unit } from '../../../../../../api/Engrain';
import UnitColorConfiguration from './UnitColorConfiguration';
import { Container } from 'reactstrap';

interface Props {
    units: Unit[];
}

const UnitColorEditor = (props: Props) => {
    const context = useContext(MapContext);

    let availableUnits = props.units.filter(a => {
        return !context.configuration.units.some(u => u.unitId === a.id);
    });
    const handleUnitChanged = (index: number, stopConfig?: MapUnitDto) => {
        let newUnits = context.configuration.units;
        if (stopConfig === undefined) {
            newUnits.splice(index, 1);
        } else {
            newUnits[index] = stopConfig;
        }

        context.setConfiguration({ ...context.configuration, units: newUnits });
    };
    return (
        <div className="d-flex flex-column">
            <h4>Unit Colors</h4>
            <Container className="editor-container">
                {context.configuration.units && context.allFloors ? (
                    context.configuration.units.map((unit, index) => {
                        let thisUnit = props.units.find(u => u.id === unit.unitId.toString());
                        if (!thisUnit) {
                            handleUnitChanged(index);
                        }
                        return (
                            <div key={index}>
                                {thisUnit && (
                                    <UnitColorConfiguration
                                        unit={unit}
                                        unitList={availableUnits.concat([
                                            { id: unit.unitId, name: thisUnit.name }
                                        ])}
                                        onUnitChanged={newConfig => {
                                            handleUnitChanged(index, newConfig);
                                        }}
                                        unitColors={context.colors}
                                    />
                                )}
                            </div>
                        );
                    })
                ) : (
                    <h2>Loading</h2>
                )}
            </Container>
            {context.configuration.stops && context.allFloors && (
                <Button
                    text="Color Unit"
                    onClick={() => {
                        return (
                            context.allFloors &&
                            handleUnitChanged(context.configuration.units.length, {
                                unitId: availableUnits[0].id,
                                unitColor: context.colors[0],
                                unitColorId: context.colors[0].id
                            })
                        );
                    }}
                />
            )}
        </div>
    );
};

export default UnitColorEditor;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/unitMapControls/UnitColorEditor.tsx